import { InjectionToken } from '@angular/core';
import { FrontendAppConfiguration } from './services/configuration.services';

export const APP_CONFIGURATION_TOKEN = new InjectionToken<FrontendAppConfiguration>(
    'AppConfiguration'
);
